import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import {
	getCompanyAdminNotifications,
	getCompanyAdminUnreadNotifications,
} from '@/app/services/notifications/notifications';
// import JwtService from '@/app/services/jwtService';
import Calendar from './superAdminCalendar';
import Notifications from './superAdminNotifications';
import './superAdminTopNav.css';
import * as Actions from '@/app/store/actions';
import * as userActions from '@/app/auth/store/actions';
import Pusher from 'pusher-js';
import { useNavigate } from 'react-router-dom';
import { stopBeamsClient } from '@/utils/utils';

const useStyles = makeStyles(() => ({
	separator: {
		marginTop: 15,
		width: 1,
		height: 60,
		backgroundColor: 'rgba(0, 0, 0, 0.12)',
	},
}));

const SuperAdminTopNav = () => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const [notifications, setNotifications] = useState([]);
	const [loadingNotifications, setLoadingNotifications] = useState(false);
	const [unreadCount, SetunreadCount] = useState(0);
	const [hasMore, setHasMore] = useState(false);
	const [page, setPage] = useState(1);
	const [fetchingMore, setFetchingMore] = useState(false);
	const user = useSelector(({ auth }) => auth.user);
	const [refresh, setRefresh] = useState(false);
	const navigate = useNavigate();
	let pusher;
	let channel;

	useEffect(() => {
		let beamsClient;

		setTimeout(() => {
			window.navigator.serviceWorker.ready.then(() => {
				getCompanyAdminUnreadNotifications()
					.then((res) => SetunreadCount(res.data.count))
					.catch((err) => {
						if (err?.response.status !== 403) {
							console.log(err);
						}
					});
				getCompanyAdminNotifications(1)
					.then((res) => {
						setNotifications([...notifications, ...res.data.data]);
						if (res.data.last_page > res.data.current_page) {
							setHasMore(true);
							setPage(page + 1);
						} else {
							setHasMore(false);
						}
					})
					.catch((err) => {
						if (err?.response.status !== 403) {
							console.log(err);
						}
					})
					.finally(() => setLoadingNotifications(false));
			});
		}, 5000);
		setLoadingNotifications(true);

		const handleNotificationCount = (e) => {
			SetunreadCount(e.data.data.unread_notification_count);
			getCompanyAdminNotifications(1)
				.then((res) => {
					setNotifications([...res.data.data, ...notifications]);
					if (res.data.last_page > res.data.current_page) {
						setHasMore(true);
						setPage(page + 1);
					} else {
						setHasMore(false);
					}
				})
				.catch((err) => console.log(err))
				.finally(() => setLoadingNotifications(false));
		};
		navigator.serviceWorker.addEventListener('message', handleNotificationCount);

		return () => {
			stopBeamsClient(beamsClient);

			navigator.serviceWorker.removeEventListener('message', handleNotificationCount);
			setRefresh(false);
		};
	}, []);

	useEffect(() => {
		pusher = new Pusher(import.meta.env.VITE_PUSHER_CHANNEL_ID, {
			cluster: import.meta.env.VITE_PUSHER_CLUSTER_ID,
		});
		channel = pusher.subscribe(`company_app_${user.data.school.id}`);
		channel.bind('company_disabled', realtimeLogout);
		return () => {
			pusher.disconnect();
		};
	}, []);

	const realtimeLogout = () => {
		dispatch(userActions.logoutUser());
		dispatch(
			Actions.showMessage({
				message: 'Something went wrong please contact with your administrator',
				variant: 'error',
				autoHideDuration: 3000,
			})
		);
		pusher.disconnect();
		navigate('/login');
	};

	const handleLoadMore = () => {
		setFetchingMore(true);
		getCompanyAdminNotifications(page)
			.then((res) => {
				setNotifications([...notifications, ...res.data.data]);
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
					setPage(page + 1);
				} else {
					setHasMore(false);
				}
			})
			.catch((err) => console.log({ ...err }))
			.finally(() => setFetchingMore(false));
	};

	return (
		<div className="flex justify-between items-center">
			<div>
				<Calendar />
			</div>
			<div className={classes.separator} />
			<div className="icons-wrapper flex">
				<div className="icon-wrapper">
					<Notifications
						SetunreadCount={SetunreadCount}
						fetchingMore={fetchingMore}
						handleLoadMore={handleLoadMore}
						hasMore={hasMore}
						loadingNotifications={loadingNotifications}
						notifications={notifications}
						refresh={refresh}
						setLoadingNotifications={setLoadingNotifications}
						setNotifications={setNotifications}
						setRefresh={setRefresh}
						unreadCount={unreadCount}
					/>
					{unreadCount ? <span className="notification-count">{unreadCount}</span> : ''}
				</div>
			</div>
		</div>
	);
};

export default SuperAdminTopNav;
